import { distance } from '@turf/turf';
import { Button, Icon } from '@nazka/nazka.mapframe.components';
import { faArrowUpRightFromSquare } from '@fortawesome/pro-solid-svg-icons';

import { useRoute, useStop } from '@services/query.service';
import { formatDistance } from '@services/utils.service';

import './nearby-stop-popup.styl';

function NearbyStopPopup({
  stop,
  origin,
  destination,
}) {
  const { data: walkRoute } = useRoute(origin, destination, 'WALK');
  const { data: bicycleRoute } = useRoute(origin, destination, 'BICYCLE');
  const { data: stopInformation } = useStop(stop.id);

  const distanceToNearbyStop = distance([origin.lng, origin.lat], [destination.lng, destination.lat], { units: 'meters' });

  return (
    <div className="nearby-stop-popup">
      <div className="nearby-stop-popup__title">
        {stop.name}
      </div>
      {stopInformation?.url && (
        <Button 
          className="nearby-stop-popup__url"
          icon={faArrowUpRightFromSquare}
          iconSize="12px"
          href={stopInformation.url}
          rootElProps={{
            target: '_blank',
            rel: 'noopener noreferrer',
            title: 'bekijk op website aanbieder',
          }}
          layout="ghost"
          hover={false}
        />
      )}
      <div className="nearby-stop-popup__content">
        <div className="nearby-stop-popup__content__distance">
          <div className="nearby-stop-popup__content__distance__main">
            {stopInformation?.vehicleMode === 'BUS' && (
              <Icon
                icon="/img/icons/bus.svg"
                size="14px"
                rootElProps={{
                  title: 'bus',
                }}
              />
            )}
            {stopInformation?.vehicleMode === 'RAIL' && (
              <Icon
                icon="/img/icons/train.svg"
                size="16px"
                rootElProps={{
                  title: 'trein',
                }}
              />
            )}
            {' '}
            <span>{formatDistance(distanceToNearbyStop)}</span>
          </div>
          <div className="nearby-stop-popup__content__distance__time">
            {walkRoute && (
              <div className="nearby-stop-popup__content__distance__time__item">
                <Icon 
                  className="nearby-stop-popup__content__distance__time__item__icon"
                  icon="/img/icons/transport_types/walking.svg"
                  size={{
                    height: '16px',
                    width: '10px',
                  }}
                  rootElProps={{
                    title: 'te voet',
                  }}
                />
                <span>
                  {`${Math.round(walkRoute.routeInformation.duration / 60)} min`}
                </span>
              </div>
            )}
            {bicycleRoute && (
              <div className="nearby-stop-popup__content__distance__time__item">
                <Icon 
                  className="nearby-stop-popup__content__distance__time__item__icon"
                  icon="/img/icons/transport_types/bike.svg"
                  size={{
                    height: '18px',
                    width: '20px',
                  }}
                  rootElProps={{
                    title: 'met fiets',
                  }}
                />
                <span>
                  {`${Math.round(bicycleRoute.routeInformation.duration / 60)} min`}
                </span>
              </div>
            )}
          </div>
        </div>
        {stopInformation && stopInformation && stop?.agency !== 'nmbs' && (
          <div className="nearby-stop-popup__content__lines">
            {stopInformation?.routes && stopInformation.routes.map(route => (
              <div
                className="nearby-stop-popup__content__lines__line"
              >
                <div
                  style={{ 
                    backgroundColor: `#${route.color}`, 
                    color: `#${route.textColor}`, 
                    borderColor: `#${route.textColor}`, 
                  }}
                  className="nearby-stop-popup__content__lines__line__code"
                >
                  {route.shortName}
                </div>
                {route.longName}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default NearbyStopPopup;